import { render, staticRenderFns } from "./EditarArquivamento.vue?vue&type=template&id=5911bf38"
import script from "./EditarArquivamento.vue?vue&type=script&lang=js"
export * from "./EditarArquivamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports